module.exports = __webpack_public_path__ + "static/media/icon-parking.a4fafbd8.svg";